<template>
	<span>
		<a
			href="#"
			:class="['action', { 'red': exclusionType, 'loading': calling }]"
			v-b-tooltip
			:title="title"
			@click.prevent="onClick"
		>
			<Icon icon="minus-circle"/>
		</a>
	</span>
</template>

<script>
import Icon from "@/vue/icon/Icon";
import JobProfileExclusion from "@/api/customer/job-profile/applicant/Exclusion"
import CustomerExclusion from "@/api/customer/applicant/Exclusion"
import * as Log from "@/helper/Log";
import {mapActions} from "vuex";
import EventBus from "@/event/EventBus";
import * as Event from "@/event/Event";

const EXCLUSION_TYPE_JOB_PROFILE = 'job-profile';
const EXCLUSION_TYPE_CUSTOMER = 'customer';

export default {

	components: {
		Icon,
	},

	props: {
		jobProfileId: {
			type: String,
			required: true,
		},
		jobId: {
			type: String,
			required: true,
		},
		applicant: {
			type: Object,
			required: true,
		},
		permissionJobProfile: {
			type: Boolean,
			required: true,
		},
		permissionComprehensive: {
			type: Boolean,
			required: true,
		},
		initialExclusionType: {
			type: String,
			required: false,
		}
	},

	mounted ()
	{
		this.eventAddHandler = ({applicant, exclusionType}) =>
		{
			if (applicant.id === this.applicant.id)
			{
				this.exclusionType = exclusionType;

				if (exclusionType)
				{
					this.$emit('exclude', exclusionType);
				}
			}
		};

		EventBus.$on(Event.JOB_PROFILE_APPLICANT_EXCLUDED, this.eventAddHandler);

		this.eventRemoveHandler = ({applicant}) =>
		{
			if (applicant.id === this.applicant.id)
			{
				this.exclusionType = undefined;
			}
		};

		EventBus.$on(Event.JOB_PROFILE_APPLICANT_EXCLUSION_REMOVED, this.eventRemoveHandler);
	},

	beforeDestroy ()
	{
		EventBus.$off(Event.JOB_PROFILE_APPLICANT_EXCLUDED, this.eventAddHandler);
		EventBus.$off(Event.JOB_PROFILE_APPLICANT_EXCLUSION_REMOVED, this.eventRemoveHandler);
	},

	data ()
	{
		return {
			exclusionType: this.initialExclusionType,
			calling: false,
			exclusionTypes: {
				jobProfile: EXCLUSION_TYPE_JOB_PROFILE,
				customer: EXCLUSION_TYPE_CUSTOMER,
			},
			eventAddHandler: undefined,
			eventRemoveHandler: undefined,
		};
	},

	computed: {
		title ()
		{
			if (!this.exclusionType)
			{
				return 'Kandidat ausschließen';
			}

			return this.exclusionType === EXCLUSION_TYPE_CUSTOMER
				? 'Die Person ist von ALLEN Jobs ausgeschlossen; Ausschluss per Klick entfernen'
				: 'Die Person ist von diesem Job ausgeschlossen; Ausschluss per Klick entfernen'
		},
	},

	methods: {
		...mapActions('jobResult/exclusion/applicant', {
			'openExclusionFan': 'show'
		}),
		onClick ()
		{
			if (this.removing)
			{
				return;
			}

			if (!this.exclusionType)
			{
				this.openExclusionFan({
					jobProfileId: this.jobProfileId,
					jobId: this.jobId,
					applicant: this.applicant,
					permissionJobProfile: this.permissionJobProfile,
					permissionComprehensive: this.permissionComprehensive,
					onExclude: ({exclusionType}) =>
					{
						this.exclusionType = exclusionType;

						this.$emit('exclude', exclusionType);
					}
				});

				return;
			}

			this.removeExclusion();
		},
		async removeExclusion ()
		{
			this.calling = true;

			try
			{
				if (this.exclusionType === EXCLUSION_TYPE_JOB_PROFILE)
				{
					await new JobProfileExclusion()
						.setJobProfileId(this.jobProfileId)
						.setPseudonymId(this.applicant.id)
						.remove()
						.call();
				}
				else
				{
					await new CustomerExclusion()
						.setPseudonymId(this.applicant.id)
						.remove()
						.call();
				}

				this.$emit('remove');

				EventBus.$emit(Event.JOB_PROFILE_APPLICANT_EXCLUSION_REMOVED, {
					applicant: this.applicant,
					exclusionType: this.exclusionType,
				});

				this.exclusionType = undefined;
			}
			catch (e)
			{
				Log.error(e);
			}

			this.calling = false;
		},
	},
}
</script>
